// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-24eeb92a]{display:flex;flex-direction:row;vertical-align:middle}.logo img[data-v-24eeb92a]{height:56px}.logo .name[data-v-24eeb92a]{margin-left:14px}.logo .name .title[data-v-24eeb92a]{color:#084198;font-size:28px;font-weight:500;line-height:36px}.logo .name .sub[data-v-24eeb92a]{color:#7b7b7b;font-size:12px;font-weight:400;line-height:20px;float:left}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
